module.exports = __webpack_public_path__ + "static/media/epic-banner_fr.bc33ba67.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/epic-banner_fr.png
// module id = 567
// module chunks = 0